import React from 'react';
import { ClubOverviewSection } from './ClubOverviewSection';
import { ClubMomentsStrip } from './ClubMomentsStrip';
import { Typography } from '../../common/Typography';

/**
 * "Your moments" container for the My Club overview tab.
 * Activity feed moments already include matchup-type events (first wins, hot streaks, etc.)
 * so no separate matchups strip is needed here.
 */
export function ClubActivitySection({
  moments,
  momentsLoading,
  currentUser,
}) {
  if (!momentsLoading && (!moments || moments.length === 0)) return null;

  return (
    <ClubOverviewSection label="Your moments" variant="moments">
      {momentsLoading || (moments && moments.length > 0) ? (
        <ClubMomentsStrip
          moments={moments}
          loading={momentsLoading}
          currentUser={currentUser}
          embedded
        />
      ) : (
        <Typography variant="muted" className="text-center py-4">
          No moments yet — play in a session to earn your first highlight.
        </Typography>
      )}
    </ClubOverviewSection>
  );
}
